import { render } from "./CloseConversationConfiguration.vue?vue&type=template&id=36a3b7bb&scoped=true&lang=pug"
import script from "./CloseConversationConfiguration.vue?vue&type=script&lang=js"
export * from "./CloseConversationConfiguration.vue?vue&type=script&lang=js"

import "./CloseConversationConfiguration.vue?vue&type=style&index=0&id=36a3b7bb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a3b7bb"]])

export default __exports__